var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaCorporate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#79a125;}.cls-3{fill:#f7b483;}.cls-4{fill:#fec9a3;}.cls-5{fill:#4398d1;}.cls-6{fill:#f0e4d6;}.cls-7{fill:#ccbfb0;}.cls-8{fill:#91562f;}.cls-9{fill:#88b337;}.cls-10{fill:#ebab7c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85,22.9H80A14.9,14.9,0,0,1,94.9,8h5A14.9,14.9,0,0,1,85,22.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80,47.72h5a17.38,17.38,0,0,0,17.38-17.38h-5A17.38,17.38,0,0,0,80,47.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.51,120.78,94.9,102.24,80,77.51H60.14L35.31,102.34l48.41,48.11A5.25,5.25,0,1,0,91.17,143h0a5.26,5.26,0,0,0,7.45-7.42,5.26,5.26,0,0,0,7.45-7.42h0a5.25,5.25,0,0,0,7.56-7.3A.68.68,0,0,0,113.51,120.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50.21,117.23l-3.73,3.7a5.2,5.2,0,0,0,0,7.34l0,0a5.3,5.3,0,0,0,7.45,0,5.18,5.18,0,0,0,0,7.34l0,0a5.3,5.3,0,0,0,7.45,0,5.2,5.2,0,0,0,0,7.35l0,0a5.3,5.3,0,0,0,7.45,0,5.18,5.18,0,0,0,0,7.34l0,0h0a5.3,5.3,0,0,0,7.45,0L80,146.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 10.31,
    y: 59.53,
    width: 35.1,
    height: 21.06,
    transform: "translate(-41.38 40.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 121.61,
    y: 52.51,
    width: 21.06,
    height: 35.1,
    transform: "translate(-10.84 113.96) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 109.7,
    y: 66.17,
    width: 17.55,
    height: 35.1,
    transform: "translate(-24.5 108.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 23.96,
    y: 74.94,
    width: 35.1,
    height: 17.55,
    transform: "translate(-47.04 53.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 32.83,
    y: 87.44,
    width: 4.97,
    height: 4.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 122.2,
    y: 87.44,
    width: 4.97,
    height: 4.97
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "80 55.17 65.1 70.06 94.89 70.06 80 55.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 77.51,
    y: 22.9,
    width: 4.97,
    height: 34.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M60.14,8h5A14.9,14.9,0,0,1,80,22.9H75A14.9,14.9,0,0,1,60.14,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M80,47.72H75A17.38,17.38,0,0,1,57.66,30.34h5A17.38,17.38,0,0,1,80,47.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.86,77.51H75L52.69,100.38a14,14,0,0,0,19.86.63L75,97.37a20,20,0,0,0,20.11,5.22l14.65,14.64,7.45-7.44,7.45-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M106.07,130.68a2.52,2.52,0,0,1-1.76-.72l-3.72-3.71a2.49,2.49,0,1,1,3.51-3.52h0l3.72,3.71a2.48,2.48,0,0,1,0,3.51A2.44,2.44,0,0,1,106.07,130.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M98.62,138.32a2.47,2.47,0,0,1-1.75-.72l-3.73-3.71a2.49,2.49,0,0,1,3.51-3.52l3.72,3.71a2.48,2.48,0,0,1-1.75,4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M91.17,145.77a2.44,2.44,0,0,1-1.75-.73l-3.73-3.7a2.49,2.49,0,1,1,3.51-3.52l3.72,3.71a2.48,2.48,0,0,1-1.75,4.24Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaCorporate);
export default __webpack_public_path__ + "static/media/ka_corporate.efa3a6a0e6788e83eec3517042575347.svg";
export { ForwardRef as ReactComponent };